@if (definition(); as icon) {
  <svg
    class="app-icon"
    [attr.width]="size()"
    [attr.height]="size()"
    [attr.viewBox]="icon.viewBox"
    fill="currentColor"
    focusable="false"
    [attr.aria-hidden]="ariaHidden() ? 'true' : null"
    [attr.role]="isMeaningful() ? 'img' : null"
    [attr.aria-label]="isMeaningful() ? ariaLabel() : null"
  >
    @for (path of icon.paths; track path) {
      <path [attr.d]="path" />
    }
  </svg>
} @else {
  <span
    class="app-icon app-icon--missing"
    [attr.aria-hidden]="ariaHidden() ? 'true' : null"
    [attr.role]="isMeaningful() ? 'img' : null"
    [attr.aria-label]="isMeaningful() ? ariaLabel() : null"
    [style.width.px]="size()"
    [style.height.px]="size()"
    title="Icona non registrata: {{ name() }}"
  ></span>
}
